import React from 'react'
import PageTitle from '../global/PageTitle/PageTitle'
export default function CreateRequisition() {
  return (
    <div class ="create-req">
       <PageTitle title="Create Requisition" />
     
    <a className="req-link" href="#">Search Catalog</a><br/>
   <div className='req-field'> Search the internal catalog of preferred items and suppliers to add into shopping cart </div>
   <br/>
<hr/>
<a className="req-link" href="#">Request Non -Catalog items</a><br/>
   <div className='req-field'> Request services or Repair & Maintenance </div>
   <br/>
<hr/>
<a className="req-link" href="#">Connect to supplier Website</a><br/>
   <div className='req-field'> Request goods and services from supplier website </div>
   <br/>
<hr/>
    </div>
  )
}